import { render, staticRenderFns } from "./LessonsRatingDanish.vue?vue&type=template&id=3538d9cd"
import script from "./LessonsRatingDanish.vue?vue&type=script&lang=js"
export * from "./LessonsRatingDanish.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports